"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetFiltersButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const _1 = require("./");
const ResetFiltersButton = ({ buttonWrapper, buttonLabel, onFilterReset, }) => ((0, jsx_runtime_1.jsx)(_1.TablePortal, { wrapperEl: buttonWrapper, children: (0, jsx_runtime_1.jsx)("a", { className: "table-filters-reset", onClick: onFilterReset, children: (0, jsx_runtime_1.jsxs)("span", { className: "cta-content", children: [(0, jsx_runtime_1.jsx)("span", { className: "icon icon-refresh" }), (0, jsx_runtime_1.jsx)("span", { className: "cta-content-text", children: buttonLabel })] }) }) }));
exports.ResetFiltersButton = ResetFiltersButton;
exports.default = exports.ResetFiltersButton;
